import { Injectable, inject } from '@angular/core';

import { Tenant } from '@models/module/tenant';
import { HttpService } from '@shared/services/http.service';

@Injectable({
  providedIn: 'root',
})
export class TenantService {
  http = inject(HttpService);

  getTenants() {
    return this.http.get<Tenant[]>('_api/Main/Tenants', { useLoader: false });
  }
}
